import PropTypes from 'prop-types';

export * from './common/redux';

/** @deprecated */
export const ReactNode = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);
